import NotFoundPage from "pages/private/NotFoundPage";
import { useState, useEffect, useRef } from "react";
import { ErrorResponse } from "react-router-dom";
import LoadingPage from "../Molecules/LoadingPage";

interface EntityProviderProps<T> {
  children: (entity: T, setEntity: Function) => any;
  callback: Function;
  notFoundComponent?: any;
  params?: Array<string | boolean | number | undefined>;
}

const EntityProvider = <T extends object>({
  children,
  callback,
  notFoundComponent,
  params,
}: EntityProviderProps<T>) => {
  const [entity, setEntity] = useState<T | null>(null);
  const [error, setError] = useState<ErrorResponse | null>(null);
  const ranOnce = useRef<boolean>(false);

  useEffect(() => {
    if (!ranOnce.current) {
      ranOnce.current = true;
      callback(...(params ?? []))
        .then((res: T) => {
          if (res && !("error" in res)) {
            setEntity(res);
          } else {
            setError({ status: 0, statusText: "", data: "" });
          }
        })
        .catch((err: ErrorResponse) => {
          setError(err);
        });
    }
  }, []);

  if (entity === null && error === null) {
    return <LoadingPage />;
  } else if ((entity && "error" in entity) || error !== null) {
    return notFoundComponent ?? <NotFoundPage />;
  }

  return children(entity as T, setEntity);
};

export default EntityProvider;
